import { render, staticRenderFns } from "./app.vue?vue&type=template&id=05120c5c&scoped=true&"
import script from "./app.vue?vue&type=script&lang=ts&"
export * from "./app.vue?vue&type=script&lang=ts&"
import style0 from "./app.vue?vue&type=style&index=0&id=05120c5c&prod&lang=scss&scoped=true&"
import style1 from "./app.vue?vue&type=style&index=1&id=05120c5c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05120c5c",
  null
  
)

export default component.exports